import { ElementType } from 'react'
import { TextProps, Text } from '@maas-components/core'
import styled, { css } from 'styled-components'

type TMarginProps = {
  p?: number
  py?: number
  px?: number
  pl?: number
  pr?: number
  pt?: number
  pb?: number
  m?: number
  my?: number
  mx?: number
  ml?: number
  mr?: number
  mt?: number
  mb?: number
}

type TOverrideTypographyProps = TextProps &
  TMarginProps & {
    component?: ElementType
  }

const CustomTypography = styled(Text)<TOverrideTypographyProps>`
  ${({ theme: { spacing }, ...props }) => css`
    ${props.p && `padding: ${spacing(props.p, props.p)};`}
    ${props.py && `padding-top: ${spacing(props.py)}px; padding-bottom: ${spacing(props.py)}px;`}
    ${props.px && `padding-left: ${spacing(props.px)}px; padding-right: ${spacing(props.px)}px;`}
    ${props.pl && `padding-left: ${spacing(props.pl)}px;`}
    ${props.pr && `padding-right: ${spacing(props.pr)}px;`}
    ${props.pt && `padding-top: ${spacing(props.pt)}px;`}
    ${props.pb && `padding-bottom: ${spacing(props.pb)}px;`}
    ${props.m && `margin: ${spacing(props.m, props.m)};`}
    ${props.my && `margin-top: ${spacing(props.my)}px; margin-bottom: ${spacing(props.my)}px;`}
    ${props.mx && `margin-left: ${spacing(props.mx)}px; margin-right: ${spacing(props.mx)}px;`}
    ${props.ml && `margin-left: ${spacing(props.ml)}px;`}
    ${props.mr && `margin-right: ${spacing(props.mr)}px;`}
    ${props.mt && `margin-top: ${spacing(props.mt)}px;`}
    ${props.mb && `margin-bottom: ${spacing(props.mb)}px;`}
  `}
`

export default CustomTypography
